const defaultState = {
  visibleVideo: true,
};

const mediaViewerReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'SHOW_VIDEO_VIEWER': {
      return {
        ...state,
        visibleVideo: true,
      };
    }
    case 'HIDE_VIDEO_VIEWER': {
      return {
        ...state,
        visibleVideo: false,
      };
    }
    default:
      return state;
  }
};

export default mediaViewerReducer;
